import ActivityFeed from '@app/components/ActivityFeed'
import FeedItemEditor from '@app/components/FeedItemEditor'
import { FeedItemSourceType } from '@app/models/enums'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'

type PropertyActivityProps = RouteComponentProps<{ id: string }>

class PropertyActivity extends React.PureComponent<PropertyActivityProps> {
  public render() {
    return (
      <div key={this.props.match.params.id}>
        <div className='mx-2'>
          <FeedItemEditor
            contextId={this.props.match.params.id}
            contextType={FeedItemSourceType.Property}
          />
        </div>
        <ActivityFeed contextId={this.props.match.params.id} />
      </div>
    )
  }
}

export default withRouter(PropertyActivity)
